module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("CONTENTS ")])]), _c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/foreword#foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/author_note#author_note"
    }
  }, [_vm._v("Author’s Note & Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("Chapter One             Overview")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_vm._v("Chapter Two             Opening Shots: Lt John Treacher, HMS Triumph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three           First Patrols for HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theseus")]), _vm._v(": Lt Tommy Leece ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four             Last Patrols for HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theseus")]), _vm._v(": Lt Tommy Leece ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five              HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Glory")]), _vm._v(" Enters the Conflict: Lt Michael Darlington")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six                HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ocean")]), _vm._v(" and the Irishman: Lt Paddy McKeown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven            HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ocean")]), _vm._v(" and Cook’s War: Sub Lt Nick Cook")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight           When the Migs came out to Play: Lt Peter Carmichael, HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ocean")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine             HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ocean")]), _vm._v(" and the Fireflies: Lt Harry Hawksworth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten           More Stings from the Fireflies: Lt Harry Hawksworth, HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ocean")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven          Furies Ascendant: Lt Ted Anson, HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Glory")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve       The Coal Burners: Lt Arthur Skinner, HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ocean")]), _vm._v(" and HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Glory")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen      HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Glory")]), _vm._v(" and Leahy’s War: Lt Alan Leahy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen       The RAF and RAAF ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen          Flying with the US Navy: Lieutenant J. Joe MacBrien ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/the_end#the_end",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix1#appendix1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix I:         The Prisoner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix2#appendix2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix II:         Mounts of the Fleet Air Arm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/map#map",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map of the Area")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chronology#chronology",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chronology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/glossary#glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0